import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseCRMItem, CRMItem } from '../../../../shared/models/crm/CRMItem.model';
import { CrmAlarmUtilsService } from '../../../../core/data-services/crm-alarm-utils.service';
import { CRMAlarm } from '../../../../shared/models/crm/CRMAlarm.model';
import { CrmItemType } from 'src/app/shared/enums/crm-item-type.enum';

@Component({
    selector: 'rms-archive-modal',
    templateUrl: './archive-modal.component.html',
    styleUrls: ['./archive-modal.component.scss'],
    standalone: false
})
export class ArchiveModalComponent implements OnInit {

  @Input() crmItem: BaseCRMItem;
  @Input() crmItemType: CrmItemType = CrmItemType.STANDARD;

  public archiveReason = '';
  public wakeAlarm: CRMAlarm = null;
  public readonly CrmItemType = CrmItemType;

  constructor(
    private crmAlarmUtilsService: CrmAlarmUtilsService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.wakeAlarm = this.crmAlarmUtilsService.findSilenceAlarm(this.crmItem as CRMItem);
  }

  submit() {
    this.activeModal.close(this.archiveReason);
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close(null);
  }

}
